/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import cx from "classnames";
import React, { ReactNode } from "react";

import { useActiveSection } from "./ActiveSectionContext";

import "./DropdownMenuSection.scss";

interface DropdownMenuSectionProps {
  name: string;
  withBlockPadding?: boolean;
  children: ReactNode;
}

export const DropdownMenuSection = (props: DropdownMenuSectionProps) => {
  const { name, withBlockPadding = false, children } = props;

  const { section: activeSection } = useActiveSection();

  const sectionClasses = cx("DropdownMenuSection", {
    active: activeSection === name,
    "with-block-padding": withBlockPadding,
  });

  return <div className={sectionClasses}>{children}</div>;
};
